import React from 'react';

import PropTypes from 'prop-types';
import fr from 'facet-rest';
import ActionCard from 'Components/ComponentLibrary/Organisms/ActionCard/ActionCard';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useCollectionState from 'Hooks/useCollectionState';
import DataContainer from 'Components/UI/DataContainer';

const ManagedAccountFundingInstructionCtaCard = ({
  ctaRelationship,
}) => {
  const { loadPageContentLink } = usePageContentContext();

  const { collection: ctaCollection } = useCollectionState({ link: ctaRelationship?.link('related') });

  if (!ctaCollection || ctaCollection.resources().length() === 0) {
    return null;
  }
  const ctaResource = ctaCollection.resources().head();

  const leadPlannerProfileImage = ctaResource?.relationship(fr.relationships.plannerProfileImageURL.name)?.link('related')?.url();

  const onClick = () => {
    loadPageContentLink(ctaResource.relationship(fr.relationships.fundingInstructions.name).link('related'));
  };
  return (
    <DataContainer
      loading={!ctaCollection}
      component={ActionCard}
      componentProps={{
        avatarSrc: leadPlannerProfileImage,
        avatarAlt: 'Profile picture',
        text: ctaResource.attr('text'),
        buttonLabel: 'Get started',
        buttonOnClick: onClick,
      }}
    />
  );
};

ManagedAccountFundingInstructionCtaCard.defaultProps = {};

ManagedAccountFundingInstructionCtaCard.propTypes = {
  ctaRelationship: PropTypes.object.isRequired,
};

export default ManagedAccountFundingInstructionCtaCard;
